module.exports = __webpack_public_path__ + "static/media/LoadingFragrance.df348b03.gif";